import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route, Navigate} from 'react-router';

import Authentication from './auth/Authentication';

const Router = () => {
  return (
    <Routes>
      <Route path="/signout" element={<Navigate to="/" />} />

      <Route path="*" Component={Authentication} />
    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

